import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";

const GlobalNotification = props => {
  const [open, setOpen] = useState(true);
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      key={"top,center"}
      open={open}
      onClose={() => {
        setOpen(false);
        try {
          window.localStorage.setItem("globalNotification" + props.id, true);
        } catch (e) {
          console.log(e.message);
        }
      }}
      ContentProps={{
        "aria-describedby": "message-id"
      }}
      message={<span id="message-id">{props.message}</span>}
      action={
        <Button
          onClick={() => {
            setOpen(false);
            try {
              window.localStorage.setItem(
                "globalNotification" + props.id,
                true
              );
            } catch (e) {
              console.log(e.message);
            }
          }}
          color="inherit"
          size="small"
        >
          Dismiss
        </Button>
      }
    />
  );
};

export default GlobalNotification;
